/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const utterancesTeachingBubbleMessages = defineMessages({
    entityPaletteTitle: {
        id: 'utterances.utterancesTeachingBubbleMessages.entityPaletteTitle',
        defaultMessage: 'Entity palette is here'
    },
    entityPaletteBody: {
        id: 'utterances.utterancesTeachingBubbleMessages.entityPaletteBody',
        defaultMessage: 'You can open the entity palette here. With this tool, you may enjoy a more efficient labeling experience.'
    },
    newPredictionsBehaviorTitle: {
        id: 'utterances.utterancesTeachingBubbleMessages.newPredictionsBehaviorTitle',
        defaultMessage: 'We have made some changes'
    },
    newPredictionsBehaviorBody: {
        id: 'utterances.utterancesTeachingBubbleMessages.newPredictionsBehaviorBody',
        defaultMessage:
            'From now on, unconfirmed predictions will not be labeled automatically.\
             Please confirm correct predictions to take it into account for next training.'
    }
});
